import ENV from "./ENV";
// import Manifest from 'config/Manifest'
import storageActions from "app/utils/storageActions";
import offlineQueue from "app/utils/offlineQueue";
import store from "app/redux/store";

let apiActions = {
  demoMode: null,
  async request(
    model,
    action = "GET",
    data = null,
    retry = 0,
    multipart = false,
  ) {
    const [local, token] = await Promise.all([
      storageActions.fetchItem("local", ENV.LOCAL),
      storageActions.fetchItem("token"),
    ]);
    if (local) {
      if (action == "GET") return [];
      else if (action == "POST" || action == "PATCH") return data?.value ?? null;
      else if (action == "DELETE") return { success: true };
    }
    // AI generation endpoints are not data mutations — never queue them
    const AI_ENDPOINTS = ["journal_chat", "narratives"];
    // If offline and it's a mutation (not auth), queue for later
    const shouldQueue =
      action !== "GET" &&
      !offlineQueue.isFlushing() &&
      !model?.startsWith("users/") &&
      !AI_ENDPOINTS.includes(model);
    if (shouldQueue && store.getState().app.isOnline === false) {
      await offlineQueue.enqueue({
        model, action, data, multipart,
        description: offlineQueue.describe(model, action, data),
      });
      return null;
    }
    let demoMode = apiActions.demoMode;
    if (demoMode !== true && demoMode !== false) {
      demoMode = await storageActions.fetchItem("demo");
      apiActions.demoMode = demoMode;
    }
    let url = ENV.API + model + (!!model ? ".json" : "");
    if (action == "GET" && !!data) {
      let params = Object.entries(data)
        .filter(([key, val]) => val != null)
        .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
        .join("&");
      url += `?${params}`;
      data = null;
    }
    const options = {
      body: multipart
        ? data || null
        : data
        ? JSON.stringify(data, apiActions.replacerFunc())
        : null, // must match 'Content-Type' header
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, same-origin, *omit
      headers: {
        "ngrok-skip-browser-warning": true,
        "user-agent": "Mozilla/4.0 MDN Example",
        "content-type": multipart ? "multipart/form-data" : "application/json",
        // "content-type": multipart ? "multipart/form-data" : "text/plain",
        "access-control-allow-methods": "GET, PUT, POST, DELETE",
        Authorization: token,
        "x-demo-mode": demoMode,
        // 'x-app-version': Manifest.version,
      },
      method: action, // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, cors, *same-origin
      // mode: "no-cors", // no-cors, cors, *same-origin
      redirect: "follow", // manual, *follow, error
      referrer: "no-referrer", // *client, no-referrer
    };
    // console.log(url);
    return (
      apiActions
        .fetchRetry(url, options, retry)
        .then((response) => response.json())
        // .catch(() => {});
        .catch((error) => {
          console.warn(error);
          // Queue the request if it failed due to a network error (not a server/abort error)
          if (error instanceof TypeError) {
            if (shouldQueue) {
              offlineQueue.enqueue({
                model, action, data, multipart,
                description: offlineQueue.describe(model, action, data),
              });
            }
            return null; // null = network error sentinel for flush()
          }
        })
    );
  },
  replacerFunc() {
    const visited = new WeakSet();
    return (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (visited.has(value)) {
          return;
        }
        visited.add(value);
      }
      return value;
    };
  },
  fetchRetry(url, options, n) {
    // https://dev.to/ycmjason/javascript-fetch-retry-upon-failure-3p6g
    console.log("-----------------", url);
    return new Promise((resolve, reject) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        console.warn("[apiActions] Request timed out:", url);
        controller.abort();
      }, 120000);
      fetch(url, { ...options, signal: controller.signal })
        .then((response) => {
          clearTimeout(timeoutId);
          if (response?.status == 401) {
            // unauthorized
            // store.dispatch(setLoading(true));
            storageActions.clearAll();
            reject(response);
            return;
          }
          if (!response?.url.endsWith("test_network") || !response?.ok)
            console.log(
              `==RESPONSE ${response?.status}: ${
                response?.ok ? "OK" : "BAD"
              } - ${response?.url}`,
              response,
            );
          const contentType = response?.headers.get("content-type");
          if (contentType && contentType?.indexOf("application/json") !== -1) {
            resolve(response);
          } else {
            console.warn(`response is not json. ${n} retries left`);
            if (n === 0) return reject(`Network not found`);
            // if(n === 0) return
            apiActions
              .fetchRetry(url, options, n - 1)
              .then(resolve)
              .catch(reject);
          }
        })
        .catch((error) => {
          clearTimeout(timeoutId);
          console.log(`failed fetch attemp with ${n} retries left`);
          if (n === 0) {
            // Mark offline on true network errors (not timeouts)
            if (error instanceof TypeError && !offlineQueue.isFlushing()) {
              offlineQueue.markOffline();
            }
            return reject(error);
          }
          apiActions
            .fetchRetry(url, options, n - 1)
            .then(resolve)
            .catch(reject);
        });
    });
  },
};

export default apiActions;
